<template>
    <v-row class="pb-offset pt-4">
		<v-col class="pa-0 px-4">
            <v-card elevation="1" class="background-2 round-card">
                <v-tabs
					class="px-2"
                    :height="34"
                    background-color="background-2"
                    slider-color="primary">
                    <v-tab :key="1">{{ integration.name }}</v-tab>

                    <v-tab-item :key="1">

                        <v-card class="elevation-0 backgroun-2">
                            <v-container class="background-2 pa-0 pt-2" fluid>
                                <v-row class="pb-3">

                                    <v-col class="d-flex pa-4" cols="12" sm="6">
                                        <v-switch inset class="ma-5 pl-3" v-model="integration.active" label="Attiva" color="primary"></v-switch>
                                    </v-col>

                                </v-row>
                            </v-container>
                        </v-card>

                        <v-card-actions class="background-2 pa-3">
                            <v-spacer></v-spacer>
                            <v-btn class="ma-2" color="primary" @click="updateStatus()">Salva</v-btn>
                        </v-card-actions>

                    </v-tab-item>

                </v-tabs>
			</v-card>

		</v-col>
		<v-snackbar
			:timeout= 6000
			color="success"
			v-model="snackbar">
			<span class="fw500">{{ snackbarText }}</span>
			<v-btn dark text @click.native="snackbar = false">Chiudi</v-btn>
		</v-snackbar>
	</v-row>
</template>

<script>
    
	export default {
        name:'enable-integration',
        props: {
            id: Number,
        },
		data() {
			return {
				snackbar: false,
				snackbarText: '',
                integration: {},
			}
		},

		created() {
			this.axios.get('integrationsapps/' + this.id).then(response => {
			    // get body data
                this.integration = response.data.data

			   	this.$store.commit('endProgress')

			}, response => {
			    // error callback
			});
		},

		methods: {

			updateStatus() {
                this.axios.put('integrationsapps/' + this.id, this.integration).then(response => {
                    // get body data
                    this.$store.commit('endProgress')
                    this.snackbar = true
				    this.snackbarText = 'Aggiornato con successo'
                    this.integration = response.data.data.model
                }, response => {
                    // error callback
                })
			},


		},

	}
</script>
